/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// This is the calendar used by the lottery date picker
import { Component } from 'react';
import PropTypes from 'prop-types';
import { gnoment, gnomentToCalendarDate, calendarDateToGnoment } from 'shared-ui/gnoment';
import { DatePicker } from 'sarsaparilla';

export default class SingleDatePickerCalendar extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        isDayBlocked: PropTypes.func.isRequired,
        selectedDate: PropTypes.shape({}),
        id: PropTypes.string,
        disabled: PropTypes.bool,
        initialVisibleMonth: PropTypes.any,
    };

    static defaultProps = {
        selectedDate: {},
        id: undefined,
        disabled: undefined,
    };

    constructor(props) {
        super(props);
        this.handleSingleDatePickerChange = this.handleSingleDatePickerChange.bind(this);
    }

    handleSingleDatePickerChange(date, isInvalid) {
        if (gnoment.isGnoment(date)) {
            const startOfDate = date.utc(true).startOf('day');
            this.props.onChange(startOfDate, this.props.id, isInvalid);
        } else {
            this.props.onChange(date, this.props.id);
        }
    }

    getSelectedDate() {
        if (
            this.props.selectedDate === null ||
            typeof this.props.selectedDate === 'undefined' ||
            (Object.keys(this.props.selectedDate).length === 0 &&
                this.props.selectedDate.constructor === Object)
        ) {
            return null;
        }
        return gnoment(this.props.selectedDate).utc();
    }

    getDayType = (day) => {
        if (this.props.isDayBlocked(day)) {
            return 'blocked';
        }
        return 'available';
    };

    render() {
        return (
            <DatePicker
                id={this.props.id ? this.props.id : 'selectedDateId'}
                value={
                    this.getSelectedDate()
                        ? gnomentToCalendarDate(this.getSelectedDate())
                        : null
                }
                onChange={(date, validation) =>
                    this.handleSingleDatePickerChange(
                        calendarDateToGnoment(date),
                        validation?.isInvalid
                    )
                }
                placeholderValue={
                    this.props.initialVisibleMonth
                        ? gnomentToCalendarDate(this.props.initialVisibleMonth.utc())
                        : null
                }
                numVisibleMonths={1}
                getDayType={(day) => this.getDayType(calendarDateToGnoment(day))}
                isDateUnavailable={(value) =>
                    this.props.isDayBlocked(calendarDateToGnoment(value))
                }
                isDisabled={this.props.disabled}
            />
        );
    }
}
